class PromotionCampaignController extends AbstractEntityEditController
	@register()
	@inject '$scope',
		'productCategories'
		'productFilters'
		'customerGroups'
		'PromotionCampaignService'
		'ConfigurationService'
		'CopyService'
		'PROMOTION_CONSTANTS'
		'BACKEND_PROMOTION_QUALIFICATION_TYPE'
		'BACKEND_PROMOTION_BENEFIT_TYPE'
		'BACKEND_PROMOTION_CAMPAIGN_ENTITY_TYPE'
		'EntityAttributeService'
		'CronDataService'
		'PromotionCampaignModel'
		'const': 'PROMOTION_CONSTANTS'
		'qualificationTypes': 'BACKEND_PROMOTION_QUALIFICATION_TYPE'
		'benefitTypes': 'BACKEND_PROMOTION_BENEFIT_TYPE'
		'BACKEND_PROMOTION_CAMPAIGN_ENTITY_TYPE'

	initialize: ->
		@isRecurrent = false
		@recurrences = []

		@showFreeItemSubtypes = false
		@attributesService = @EntityAttributeService.getNewInstance()
		@isShopGroupEnabled = @ConfigurationService.isEnabled 'Backoffice.ShopManagement.Shops.EnableShopGroups'
		@mainCrud.entityType = 'general.promotion'
		@mainCrud.entityTitle = 'wbo.promotion.new'
		@mainCrud.isNewEntity = true
		@mainCrud.showSave = @ConfigurationService.isEnabled 'Backoffice.PromotionManagement.EnableMaintenance'
		@mainCrud.showDelete = @ConfigurationService.isEnabled 'Backoffice.PromotionManagement.EnableDeletion'

		@qualificationTypeTabs = [
			{
				# Sales Value
				value: @qualificationTypes.SALES_VALUE
				label_key: 'wbo.promotion.qualification.type.sales'
				tooltip_key: 'wbo.promotion.tooltip.qualification.type.sales'
			}
			{
				# Value Same
				value: @qualificationTypes.VALUE_OF_ELIGIBLE_ITEMS
				tooltip_key: 'wbo.promotion.tooltip.qualification.type.sales_item'
				label_key: 'wbo.promotion.qualification.type.value.same'
			}
			{
				# Value Any
				value: @qualificationTypes.VALUE_OF_ANY_ELIGIBLE_ITEM
				tooltip_key: 'wbo.promotion.tooltip.qualification.type.value_any'
				label_key: 'wbo.promotion.qualification.type.value.any'
			}
			{
				# Quantity Same
				value: @qualificationTypes.QUANTITY_OF_SINGLE_ELIGIBLE_ITEM
				tooltip_key: 'wbo.promotion.tooltip.qualification.type.quantity_same'
				label_key: 'wbo.promotion.qualification.type.quantity.same'
			}
			{
				# Quantity Any
				value: @qualificationTypes.QUANTITY_OF_ANY_ELIGIBLE_ITEM
				tooltip_key: 'wbo.promotion.tooltip.qualification.type.quantity_any'
				label_key: 'wbo.promotion.qualification.type.quantity.any'
			}
			{
				# Discount Code
				value: @qualificationTypes.DISCOUNT_CODE
				tooltip_key: 'wbo.promotion.tooltip.qualification.type.discount_code'
				label_key: 'wbo.promotion.qualification.type.discount_code'
			}
		]

		@datePicker =
			timePicker: true

		@promotion = @PromotionCampaignModel.data()

		if @promotion.id?
			#@PromotionCampaignModel.initBenefit()
			@mainCrud.isNewEntity = false
			@mainCrud.entityTitle = @promotion.name
			@isRecurrent = !_.isEmpty @promotion.recurrences

			@recurrences = _.map @promotion.recurrences, (recurrence) ->
				CronDTO.fromCronExpressionAndDuration(recurrence.cron_expression, recurrence.cron_duration_seconds)

			@mainCrud.additionalButtons = [
				{
					action: 'copy'
					label: 'general.copy'
					confirmClick: => @copy()
					confirmClickLabel: 'general.copy.confirm'
				}
			]

		@promotion.eligible_sets?.forEach (set) =>
			set.qualification.expanded = true
			set.qualification.use_categories = !_.isEmpty(set.qualified_product_categories)
		@promotion.entity_type = @BACKEND_PROMOTION_CAMPAIGN_ENTITY_TYPE.PROMOTION_CAMPAIGN
		@useCategoriesForBenefits = !_.isEmpty(@promotion.benefit_product_categories)
		@initializeExternalAttributes()

		@mainCrud.tabs = [
			{
				title: 'wbo.promotion.tabs.details'
				selector: '#tab-promotion-details'
			}
			{
				title: 'wbo.promotion.tabs.qualifications'
				selector: '#tab-promotion-qualifications'
			}
			{
				title: 'wbo.promotion.tabs.benefits'
				selector: '#tab-promotion-benefits'
			}
			{
				title: 'wbo.promotion.tabs.recurrences'
				selector: '#tab-promotion-recurrences'
				disabled: !@isRecurrencesTabEnabled()
			}
		]

		@currentSubTab = 'products'
		@currentBenefitSubTab = 'products'

	initializeExternalAttributes: ->
		@attributesService.setEntity(
			@promotion
			'BACKEND_PROMOTION_CAMPAIGN_ATTRIBUTE_TYPE'
			{
				ask_for_benefit_activation: '0'
				qualify_in_multiples: '0'
				external_id: null
			}
		)

	onBenefitTypeChange: ->
		if @promotion.benefit.metatype == @const.meta.free_quantity && !@showFreeItemSubtypes
			@promotion.benefit.subtype = @const.subtype.benefit
		else
			@promotion.benefit.subtype = null

	#method used by tag input to lookup shops
	findShops: (name) ->
		@PromotionCampaignService.queryShops(name)

	findShopGroups: (name) ->
		return @PromotionCampaignService.queryShopGroups(name)

	copy: ->
		if @mainCrud.isNewEntity
			console.warn('Can not copy new entity')

			return

		data = @getPersistableData()

		@saveEntity(
			@CopyService.copyEntity(
				data,
				{'eligible_sets.qualification': ['promotion_eligible_set_id'], root: ['promotion_id']}
			),
			true
		)

	save: ->
		@saveEntity(@getPersistableData())

	getPersistableData: ->
		@attributesService.persistAttributes()

		data = @PromotionCampaignModel.data()

		data.recurrences = _.map @recurrences, (recurrence) =>
			cron_expression: @CronDataService.toCronExpression(recurrence)
			cron_duration_seconds: @CronDataService.toCronDurationSeconds(recurrence)

		if data.benefit? && data.benefit.metatype? && data.benefit.metatype == 'FREE_QUANTITY'
			data.discount_distribution_method = 'BenefitItemsOnlyProportional'

		return @PromotionCampaignModel.getPersistableData()

	saveEntity: (data, isNewEntity = @mainCrud.isNewEntity) ->
		@PromotionCampaignService
			.persist data, isNewEntity
			.then (response) =>
				@afterSave response
			.catch (result) =>
				@handleErrors result

	delete: ->
		@PromotionCampaignService
			.remove @PromotionCampaignModel
			.then =>
				@afterDelete @PromotionCampaignModel.data()
			.catch (result) =>
				@handleErrors result

	addQualification: ->
		@PromotionCampaignModel.addEligibleSet()
		@dirty()

	removeQualification: (set) ->
		@PromotionCampaignModel.removeEligibleSet(set)
		@dirty()

	resetBenefitValues: (arr) ->
		angular.forEach arr, (e) =>
			@promotion.benefit[e] = null

	forceMax: (model) ->
		percentage = parseInt(@promotion.benefit.percentage_off)

		@promotion.benefit.percentage_off = Math.min(100, percentage);

	changeSubTab: (name, set) ->
		if name == 'selected'
			set.currentSubTab = 'selected' if set.qualified_products.length > 0
		else
			set.currentSubTab = name

	changeBenefitSubTab: (name) ->
		if name == 'selected'
			@currentBenefitSubTab = 'selected' if @PromotionCampaignModel.data().benefit_products.length > 0
		else
			@currentBenefitSubTab = name

	isQuantitySame: ->
		@isQualificationType(@qualificationTypes.QUANTITY_OF_SINGLE_ELIGIBLE_ITEM)

	isQuantityAny: ->
		@isQualificationType(@qualificationTypes.QUANTITY_OF_ANY_ELIGIBLE_ITEM)

	isValueAny: ->
		@isQualificationType(@qualificationTypes.VALUE_OF_ANY_ELIGIBLE_ITEM)

	isSalesAny: ->
		@isQualificationType(@qualificationTypes.SALES_VALUE)

	isDiscountCodeAny: ->
		@isQualificationType(@qualificationTypes.DISCOUNT_CODE)

	isSalesSame: ->
		@isQualificationType(@qualificationTypes.VALUE_OF_ELIGIBLE_ITEMS)

	copyQualifiedProductsToBenefitProducts: ->
		benefitProducts = []
		angular.forEach @PromotionCampaignModel.data().eligible_sets, (set) =>
			benefitProducts = _.union(benefitProducts, angular.copy(set.qualified_products))

		@promotion.benefit_products = benefitProducts
		@promotion.benefit.promotion_benefit_type_id = @benefitTypes.FREE_ITEM

	# Ensure that if a benefit type is already selected and it is not legit in combination with the newly selected
	# qualification type we need to adjust it so it is no longer invalid
	checkQualificationValidity: (qualificationType) ->
		if [@qualificationTypes.QUANTITY_OF_ANY_ELIGIBLE_ITEM, @qualificationTypes.VALUE_OF_ANY_ELIGIBLE_ITEM].includes(qualificationType) && @promotion.benefit.metatype == @const.meta.percentage_off && @promotion.benefit.subtype == @const.subtype.benefit
			@promotion.benefit.subtype = @const.subtype.item

		if qualificationType == @qualificationTypes.QUANTITY_OF_SINGLE_ELIGIBLE_ITEM && @promotion.benefit.metatype == @const.meta.percentage_off && @promotion.benefit.subtype == @const.subtype.item
			@promotion.benefit.subtype = @const.subtype.benefit

		if [@qualificationTypes.SALES_VALUE, @qualificationTypes.VALUE_OF_ELIGIBLE_ITEMS].includes(qualificationType) && [@const.subtype.cheapest, @const.subtype.most_expensive].includes(@promotion.benefit.subtype)
			@promotion.benefit.subtype = @const.subtype.benefit

		if qualificationType == @qualificationTypes.SALES_VALUE || @promotion.benefit.metatype == @const.meta.fixed_price
			@promotion.benefit.metatype = null

	dirty: ->
		@mainCrud.parent_form.$setDirty()

	isQualificationType: (type) ->
		typeMatch = false
		angular.forEach @promotion.eligible_sets, (set) =>
			if set.qualification.promotion_qualification_type_id == type
				typeMatch = true

		typeMatch

	validateQualificationFields: (field) ->
		if !field || (field != 'value' && field != 'quantity')
			return

		minField = field + '_min'
		maxField = field + '_max'

		if !@mainCrud.isNewEntity
			prom = @promotion.eligible_sets[0].qualification
		else
			prom = @promotion.qualification

		minVal = if prom[minField] then parseFloat(prom[minField]) else undefined
		maxVal = if prom[maxField] then parseFloat(prom[maxField]) else undefined

		if minVal && maxVal && minVal > maxVal
			if !@mainCrud.isNewEntity
				@promotion.eligible_sets[0].qualification[minField] = maxVal
			else
				@promotion.qualification[minField] = maxVal

	resetQualifications: (set) ->
		set.qualified_products = []
		set.qualified_product_categories = []

	updateQualifiedProductCategories: (changedQualifiedProductCategories, set) ->
		set.qualified_product_categories = changedQualifiedProductCategories

	resetBenefits: ->
		@promotion.benefit_products = []
		@promotion.benefit_product_categories = []

	updateBenefitProductCategories: (changedBenefitProductCategories) ->
		@promotion.benefit_product_categories = changedBenefitProductCategories

	showBenefitProductsSelection: ->
		if !@promotion.benefit_products
			return false

		if !@useCategoriesForBenefits && [@const.meta.fixed_product_price, @const.meta.free_quantity].includes(@promotion.benefit.metatype)
			return true

		if @promotion.benefit.subtype == @const.subtype.selected_items && [@const.meta.percentage_off, @const.meta.amount_off].includes(@promotion.benefit.metatype)
			return true

		if @const.meta.fixed_product_price == @promotion.benefit.metatype
			return true

		return false

	toggleRecurrencesTab: ->
		tabIndex = @mainCrud.tabs.findIndex((tab) => tab.selector == '#tab-promotion-recurrences')

		@mainCrud.tabs[tabIndex].disabled = !@isRecurrencesTabEnabled()

	isRecurrencesTabEnabled: ->
		return @isRecurrent

	addRecurrence: ->
		@recurrences.push(new CronDTO())

	removeRecurrence: (index) ->
		@recurrences.splice index, 1
		@dirty()
